export const SLA = "SLA";
export const WEEKEND = "WEEKEND";
export const HOLIDAY = "HOLIDAY";
export const TIMED = "TIMED";
